import { Add } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { createProjectTour } from '@/domain/project-tour/actions/create-project-tour.action';
import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import {
  checkUserCreateTour,
  selectIsCreatingProjectTour,
} from '@/domain/project-tour/project-tour.selectors';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSSecondaryButton } from '@/ui/components/button/FSSecondaryButton';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { ProjectTourForm } from '../../components/ProjectTourForm';

const initialProjectState: ProjectTour = {
  id: -1,
  type: 'tour',
  image: '',
  name: '',
  startDate: '',
  endDate: '',
  models: {
    // TODO : refacto pour éviter de déclarer ça lors de la création (faire un objet ProjectTourFormData ?)
    ess: 'ESS_TOUR',
    env: 'ENV_TOUR',
  },
};

export function ButtonModalCreateProjectTour() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isCreatingProject = useAppSelector(selectIsCreatingProjectTour); // TODO
  const userCanCreateTour = useAppSelector(checkUserCreateTour);

  const [open, setOpen] = useState(false);
  const [project, setProject] = useState<ProjectTour>(initialProjectState);

  const onClose = () => {
    setOpen(false);
    reset();
  };

  const onSubmit = async (data: ProjectTour) => {
    try {
      const params = { project: data };
      await dispatch(createProjectTour(params)).unwrap(); // TODO
      reset();
      setOpen(false);
      navigate('/app/projects/tour');
    } catch (error) {
      console.error(error);
    }
  };

  const reset = () => {
    setProject({ ...initialProjectState });
  };

  const handleOpen = () => {
    if (userCanCreateTour) {
      setOpen(true);
    } else {
      enqueueSnackbar(translate('License.MaxEvent'), {
        variant: 'error',
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        action: (
          <FSSecondaryButton onClick={() => navigate('/app/contact')}>
            {translate('License.MaxEventAction')}
          </FSSecondaryButton>
        ),
      });
    }
  };

  return (
    <>
      <FSPrimaryButton startIcon={<Add />} onClick={handleOpen}>
        {translate('ProjectsTour.new-project-button')}
      </FSPrimaryButton>
      <FSModal open={open} onClose={onClose}>
        <Stack spacing={3}>
          <FSModalTitle
            title={translate('ProjectsTour.create-your-tour-project')}
          />
          <ProjectTourForm
            project={project}
            onSubmit={onSubmit}
            buttons={
              <FormButtons
                isCreatingProject={isCreatingProject}
                onClose={onClose}
              />
            }
          />
        </Stack>
      </FSModal>
    </>
  );
}

function FormButtons({
  isCreatingProject,
  onClose,
}: {
  isCreatingProject: boolean;
  onClose: () => void;
}) {
  return (
    <Stack
      display={'flex'}
      direction={'row'}
      justifyContent={'end'}
      spacing={1}
      sx={{ mt: 2 }}
    >
      <FSSecondaryButton onClick={onClose}>
        {translate('Form.cancel')}
      </FSSecondaryButton>
      <FSPrimaryButton disabled={isCreatingProject} type="submit">
        {translate('ProjectsTour.Form.create-tour-project')}
      </FSPrimaryButton>
    </Stack>
  );
}
